// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"233":"f9ab9011","298":"d96037c1","354":"6cc84b0d","469":"0e0a44f1","520":"dd1005b2","551":"597e0826","636":"361b3341","704":"0b61c766","945":"9f91d747","973":"2be3c4e6","984":"ad1c3933"}[chunkId] + ".chunk.js";
};